import React, { forwardRef, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { BookinPlanActions } from '../../../Services/_actions';
import { SupplierPhaseListAtom } from '../../../Services/_states';
import { useRecoilState, useRecoilValue } from 'recoil';
import ReactBootstrapTable from '../../Table/React-Bootstrap-table/ReactBootstrapTable';
import { DatePicker } from '@mui/x-date-pickers';
// import DatePicker from 'react-datepicker';

export default function ViewPhaseModal(props) {
  const BookingApi = BookinPlanActions();
  const [supplierPhaseList, setSupplierPhaseList] = useRecoilState(SupplierPhaseListAtom);
  const addNewPhase = { phase_no: '', start_date: '', end_date: '' };
  const [validated, setValidated] = useState(false);
  const [editEnable, setEditEnable] = useState(true);

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="example-custom-input btn btn-primary" onClick={onClick} ref={ref}>
      <span>{value ? value : ''}</span>
      <span sx={{ marginLeft: '5px' }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-calendar-event"
          viewBox="0 0 16 16"
        >
          <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
        </svg>
      </span>
    </div>
  ));
  const handleSelectStartDate = (date, row) => {
    let newList = supplierPhaseList.map((item) =>
      item?.id === row?.id ? { ...item, start_date: date } : item
    );
    setSupplierPhaseList(newList);
  };
  const handleSelectEndDate = (date, row) => {
    let newList = supplierPhaseList.map((item) =>
      item?.id === row?.id ? { ...item, end_date: date } : item
    );
    setSupplierPhaseList(newList);
  };

  const onPhaseChange = (e, row) => {
    let newList = supplierPhaseList.map((item) =>
      item?.id === row?.id ? { ...item, phase_no: e?.target?.value } : item
    );
    setSupplierPhaseList(newList);
  };

  const deleteSupplierPhaseObj = async (row, index) => {
    if (!row?.id) {
      let newList = [];
      for (let i in supplierPhaseList) {
        if (i != index) {
          newList.push(supplierPhaseList[i]);
        }
      }
      setSupplierPhaseList(newList);
    } else {
      await BookingApi.deletSupplierPhase(row, index);
    }
  };

  const OnSavePhase = (event) => {
    // const form = event.currentTarget;
    // if (form.checkValidity() === false) {
    //   event.preventDefault();
    //   event.stopPropagation();
    // } else {
    //   setValidated(true);
    // }
    // if (validated) {
    BookingApi.saveSupplierPhaseList(supplierPhaseList);
    // }
  };
  const phaseHeader = [
    {
      title: '#',
      accessKey: 'index',
      action: function (row, index) {
        return index + 1;
      },
    },
    {
      title: 'PHASE',
      accessKey: 'phase_no',
      sort: false,
      action: function (row, index) {
        return (
          <div>
            {/* <span>{row?.phase_no}</span>{' '} */}
            {/* <Form noValidate validated={validated}> */}
            <Form.Control
              type="text"
              id="phase_no"
              aria-describedby="phase_no"
              value={row?.phase_no}
              onChange={(e) => {
                onPhaseChange(e, row);
              }}
              required
              disabled={editEnable}
            />
            {/* <Form.Control.Feedback type="invalid">Please Enter Phase</Form.Control.Feedback>
            </Form> */}
          </div>
        );
      },
    },
    {
      title: 'START DATE',
      accessKey: 'start_date',
      sort: false,
      action: function (row, index) {
        return (
          <div>
            <Form noValidate validated={validated}>
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={row?.start_date ? new Date(row?.start_date) : ''}
                onChange={(date) => handleSelectStartDate(date, row, 'start_date')}
                customInput={<ExampleCustomInput />}
                required
                disabled={editEnable}
              />
            </Form>
          </div>
        );
      },
    },
    {
      title: 'END DATE',
      accessKey: 'end_date',
      sort: false,
      action: function (row, index) {
        return (
          <div>
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={row?.end_date ? new Date(row?.end_date) : ''}
              onChange={(date) => handleSelectEndDate(date, row, 'end_date')}
              minDate={new Date(row?.start_date)}
              customInput={<ExampleCustomInput />}
              disabled={editEnable}
            />
          </div>
        );
      },
    },
    {
      title: 'REMOVE',
      accessKey: 'index',
      sort: false,
      action: function (row, index) {
        return (
          <div className="action-icon">
            <span
              className="action-icon-item"
              onClick={(e) => {
                deleteSupplierPhaseObj(row, index);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash"
                viewBox="0 0 16 16"
              >
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
              </svg>
            </span>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div>
        {supplierPhaseList && (
          <ReactBootstrapTable headerData={phaseHeader} rowData={supplierPhaseList} />
        )}
        <div>
          <span>
            <Button
              className="btn me-3 btn-primary"
              onClick={(e) => {
                setEditEnable(!editEnable);
              }}
            >
              Edit
            </Button>
          </span>

          <span>
            <Button
              className="btn me-3 btn-primary"
              onClick={(e) => {
                setSupplierPhaseList([...supplierPhaseList, addNewPhase]);
              }}
            >
              Add
            </Button>
          </span>
          <span>
            <Button
              className="btn btn-success"
              variant="success"
              onClick={(e) => {
                OnSavePhase(e);
              }}
            >
              Save
            </Button>
          </span>
        </div>
      </div>
    </>
  );
}
